import { addBook } from "../features/Books/actions";

const addingBook = (bookDetails) => {
 return async (dispatch, getState) => {
  let response = await fetch("http://localhost:9000/books", {
   method: "POST",
   body: JSON.stringify(bookDetails),
   headers: { "Content-Type": "application/json" },
  });
  let book = await response.json();

  dispatch(addBook(book));
 };
};
export default addingBook;
